import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const WoodsIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Woods - trees */}
    <path d="M12 3l-4 6h2l-3 5h2l-4 7h14l-4-7h2l-3-5h2l-4-6z" />
    <path d="M12 14v7" />
    <path d="M5 21h14" />
  </svg>
);
